import React, { useEffect, useState } from "react";
// styles
import { pathOr, clone } from "ramda";
import useStyles from "./styles";
import { useDispatch } from "react-redux";
import { Grid, Button } from "@material-ui/core";
import { Typography } from "../Wrappers/Wrappers";

import Skeleton from '@material-ui/lab/Skeleton';
import { getModuleFieldType } from "../../store/actions/detail.actions";

import { toast } from "react-toastify";
import { FormInput } from "..";

export default function AORConditions({ data, handleSubmit, type = 'AOR_Reports', setFilterAorConditions }) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [initialValues, setInitialValues] = useState({});
  const [filterFields, setFilterFields] = useState([]);
  const [filterData, setFilterData] = useState(data);

  const [valueFieldUI, setValueFieldUI] = useState(null);
  const [fieldValueLoader, setFieldValueLoader] = useState(null);


  const handleChange = (rowNum, value, operator, fieldId, type, field) => {
    let filterOldData = clone(filterData);
    console.log("handle value",value);
    let filter = filterFields[rowNum] ? filterFields[rowNum] : {};
    filter.parameter_field = field.field;
    filter.parameter_id = fieldId;
    // filter.parameter_value = filterOldData[rowNum].condition_line[0].ModuleFieldType.value;
    // filter.parameter_type = filterOldData[rowNum].condition_line[0].FieldType.value;
    // filter.parameter_operator = filterOldData[rowNum].condition_line[0].FieldOperator.value;
    switch (type) {
      case ('operator'):
        filter.parameter_operator = value;
        break;
      case ('type'):
        filter.parameter_type = value;
        setFieldValueLoader(fieldId);
        dispatch(getModuleFieldType(rowNum, field.report_module, field.field, `aor_conditions_value[${rowNum}]`, "", value, "")).then((res) => {
          setFieldValueLoader(null);
          try {
            if (res.ok) {
              filterOldData[rowNum].condition_line[0].ModuleFieldType = pathOr([], ["data", "data", "ModuleFieldType"], res);
              setValueFieldUI(filterOldData);
            } else {
              toast("Something went wrong! else");
            }
          } catch (e) {
            toast("Something went wrong! error");

            console.log("dispatch error", e);
          }
        });

        break;
      case ('value'):
        value = (value.id) ? value.id : value;
        filter.parameter_value = value;
        break;
      default:
        break;
    }

    const tempProds = [...filterFields.map(filter => filter)];
    tempProds[rowNum] = filter;

    setFilterAorConditions(tempProds)
    setFilterFields(tempProds);
  }

  useEffect(() => {

    if (valueFieldUI != null) {
      setFilterData(valueFieldUI);
      setValueFieldUI(null);
    }
  }, [valueFieldUI, filterData])


  const triggerHandleSubmit = (e) => {
    e.preventDefault();
    console.log("filterFields", filterFields);
    handleSubmit(filterFields);
  }

  return (
    <Grid container>
      <form onSubmit={triggerHandleSubmit} className={classes.root} noValidate autoComplete="off" style={{ width: "100%" }}>

        {filterData && filterData.map((field, rowNum) => (
          <Grid container spacing={3} key={rowNum}>
            <Grid item xs={12} sm={field.length == 2 ? 6 : 12} key={rowNum}>
              <Grid container className={classes.fieldSpacing} direction="row" justify="space-between" alignItems="stretch">
                <Grid item xs={12}>
                  <Grid container direction="row" justify="space-between" alignItems="stretch">
                    {type === 'AOR_Reports' ? <Grid xs={field.length === 2 ? 4 : 2}>
                      <Typography className={classes.text} variant="subtitle2">
                        {field.report_module_label || ''} - {field.label || ""}
                      </Typography>
                    </Grid> : null}
                    <Grid item xs={type === 'Dashlet' ? 12 : field.length === 2 ? 8 : 10}>
                      {!field ? (
                        <Grid item xs={12}></Grid>
                      ) : (
                          <Grid item xs={12} container direction="row" justify="space-between" alignItems="stretch">
                            <Grid item xs={12} container direction="row" justify="space-between" alignItems="stretch">
                              {type !== 'AOR_Reports' ? 
                              <Grid item xs={12} className={classes.fieldSpacing}>
                                <Typography className={classes.text} variant="subtitle2">{field.report_module_label || ''} - {field.label || ""}</Typography>
                              </Grid> : null}
                              <Grid item xs={4} className={classes.fieldSpacing}>
                                <FormInput
                                  field={field.condition_line[0].FieldOperator}
                                  initialValues={initialValues}
                                  //value={initialValues[field.condition_line[0].FieldOperator.name]? initialValues[field.condition_line[0].FieldOperator.name]: field.condition_line[0].FieldOperator.value}
                                  value={field.condition_line[0].FieldOperator.value}
                                  //dynamicEnumValue={initialValues[field.parentenum] || ""}
                                  //errors={errors}
                                  module={module}
                                  small={true}
                                  // helperText={type!=='AOR_Reports'?field.report_module_label + " - " + field.label:null}

                                  onChange={(value) => handleChange(rowNum, value, field.condition_line[0].FieldOperator.name, field.id, 'operator', field)}
                                />
                              </Grid>
                              <Grid item xs={4} className={classes.fieldSpacing}>
                                <FormInput
                                  key={"field_" + rowNum}
                                  field={field.condition_line[0].FieldType}
                                  initialValues={initialValues}
                                  //value={initialValues[field.condition_line[0].FieldType.name]? initialValues[field.condition_line[0].FieldType.name]: field.condition_line[0].FieldType.value}
                                  value={field.condition_line[0].FieldType.value}
                                  dynamicEnumValue=""
                                  // errors={errors}
                                  module={module}
                                  small={true}
                                  onChange={(value) => handleChange(rowNum, value, field.condition_line[0].FieldType.name, field.id, 'type', field)}
                                />
                              </Grid>

                              <Grid item xs={4} className={classes.fieldSpacing}>
                                {(fieldValueLoader === field.id) ? <Skeleton animation="wave" width="100%" style={{}} variant="rect" height={40} /> :
                                  (field.condition_line[0].ModuleFieldType && field.condition_line[0].FieldType.type != 'CurrentUserID') ? (
                                    <FormInput
                                      field={field.condition_line[0].ModuleFieldType}
                                      initialValues={initialValues}
                                      //value={initialValues[field.condition_line[0].ModuleFieldType.value]?initialValues[field.condition_line[0].ModuleFieldType.value]: ""}
                                      value={field.condition_line[0].ModuleFieldType.value}
                                      dynamicEnumValue=""
                                      // errors={errors}
                                      small={true}
                                      module={module}
                                      onChange={(value) => handleChange(rowNum, value, field.condition_line[0].ModuleFieldType.value, field.id, 'value', field)}
                                    />
                                  ) : ""}
                              </Grid>

                            </Grid>

                          </Grid>
                        )}
                    </Grid>
                  </Grid>

                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ))}
        {type === 'AOR_Reports' ?
          <Grid container spacing={3} justify="space-between">
            <Grid item xs={12} sm={10}></Grid>
            <Grid item xs={12} sm={2}>
              <Button type="submit" variant="contained" size="small" color="primary" style={{ float: "right" }}> UPDATE </Button>
            </Grid>
          </Grid>
          : null}
      </form>
    </Grid>
  );
}
